/**
 * Serviços da plataforma que podem ter POS SISP próprio.
 *
 * Espelha ServicoPOS / SERVICOS_POS em
 * apps/pagali/admin/functions/src/services/sisp.service.ts — manter em sincronia.
 * O backend valida contra a sua própria lista; esta serve só para o dropdown.
 */
export const SISP_SERVICOS = [
  { code: 'EVT', i18n: 'settings.posSisp.servicos.EVT' },
  { code: 'DNT', i18n: 'settings.posSisp.servicos.DNT' },
  { code: 'IWLK', i18n: 'settings.posSisp.servicos.IWLK' },
  { code: 'PSHOP', i18n: 'settings.posSisp.servicos.PSHOP' },
  { code: 'IMENU', i18n: 'settings.posSisp.servicos.IMENU' },
  { code: 'ECM', i18n: 'settings.posSisp.servicos.ECM' },
  { code: 'FAT', i18n: 'settings.posSisp.servicos.FAT' },
  { code: 'RCG', i18n: 'settings.posSisp.servicos.RCG' },
  { code: 'RCP', i18n: 'settings.posSisp.servicos.RCP' },
  { code: 'PGME', i18n: 'settings.posSisp.servicos.PGME' },
  { code: 'WEBS', i18n: 'settings.posSisp.servicos.WEBS' },
  { code: 'TOK', i18n: 'settings.posSisp.servicos.TOK' },
  { code: 'NMH', i18n: 'settings.posSisp.servicos.NMH' },
] as const;

export type SispServicoCode = (typeof SISP_SERVICOS)[number]['code'];

/** Chave i18n de um código de serviço, ou undefined se o código for desconhecido. */
export function i18nKeyServico(code?: string | null): string | undefined {
  if (!code) return undefined;
  return SISP_SERVICOS.find((s) => s.code === code)?.i18n;
}
